import { render, staticRenderFns } from "./Interviene.vue?vue&type=template&id=1913f1c5&scoped=true&"
import script from "./Interviene.vue?vue&type=script&lang=js&"
export * from "./Interviene.vue?vue&type=script&lang=js&"
import style0 from "./Interviene.vue?vue&type=style&index=0&id=1913f1c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1913f1c5",
  null
  
)

export default component.exports